export interface ReferenceRequester {
    client?: string; // Duda
    countryCompany: string; // Bank.land
    idTransaction?: string; // Pendiente por definir
    shortKey4HouseBank: string; // Bank.ShortID4HouseBank
    salesOrg: string; // Input accountCode, igual al companyCode
    customerNo1: string; // Input customerCode
    companyCode: string; // Input accountCode
    buArea: string; // 02 Pendiente por definir
    amountLocalCurrency: string; // Input payment amount solamente dos decimales
    statusTransaction: string; // 0
    invoicePay?: string; // en advance payment seria en blanco
    datePay: string; // Fecha actual
    timePay: string; // Tiempo actual
    dateBankConfirmation: string; // Fecha actual
    timeBankConfirmation: string; //  Tiempo actual
    dateExpirationPay: string; // Fecha actual
    timeExpirationPay: string; //  Tiempo actual
    accountingDocNo?: string; // Relacionado con Facturas
    caseNoRelated?: string; // Relacionado con Facturas
    caseInternalNoRelated?: string; // Relacionado con Facturas
    shitpTo: string; // Jobsite Code
    notesCapturedPay?: string; // Relacionado con Facturas
    pruea?: string; // Dato de prueba
}

interface header {
    client: string;
    countryCompany: string; //"MX",
    idTransaction: string;
    shortKey4HouseBank: string; //"BMR01",
    salesOrg: string; //"7180",
    customerNo1: string; //"0050162810",
    companyCode: string; // "7180",
    buArea: string; // "1002",
    amountLocalCurrency: string; //"1000.00",
    statusTransaction: string; //"00",
    invoicePay: string; // "X",
    datePay: string; // "2017-03-01",
    timePay: string; //"11:16:47",
    dateBankConfirmation: string; // "2017-03-01",
    timeBankConfirmation: string; // "11:16:47",
    dateExpirationPay: string; // "2017-03-01",
    timeExpirationPay: string; // "11:16:47",
    accountingDocNo: string;
    caseNoRelated: string;
    caseInternalNoRelated: string;
    shitpTo: string; //"0065013701",
    notesCapturedPay: string;
}

interface detail {
    client: string;
    countryCompany: string; // "MX",
    idTransaction: string; // en verdad debe ser el company code
    customerNo1: string; //"0050162810",
    shortKey4HouseBank: string; // "001" reemplazar por el campo de BUZEI
    shitpTo: string; // "65013701",
    referenceCode: string;
    numberDocumentPaid: string; // "3400000315",
    documentClass: string;
    amountLocalCurrency: string; // "1000.00",
    bloquedXYes: string;
    accountingDocNo: string;
    name1: string;
    name133704237: string;
    assignmentNo: string;
    documentID: string;
}

export interface ReferencePayment {
    header?: header;
    detail?: Array<detail>;
}
